module.exports = __webpack_public_path__ + "static/media/Star of Wonder (Gloria) (ft Dear Gravity).67943b6a.jpg";